import * as React from 'react';
import { SVGProps } from 'react';

const SvgReloadDoneOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.805 9.194c.26.258.26.676 0 .934L10.889 15l-2.694-2.67a.657.657 0 0 1 0-.934.67.67 0 0 1 .943 0l1.75 1.735 3.974-3.937a.67.67 0 0 1 .943 0Z"
      fill="currentColor"
    />
    <path
      d="m16.028 16.773-.016-1.541a.872.872 0 0 0-.857-.863.824.824 0 0 0-.598.243.838.838 0 0 0-.242.602l.045 4.48 4.448.045a.83.83 0 0 0 .84-.846.872.872 0 0 0-.857-.863l-1.573-.016c.038.085-1.235-1.197-1.19-1.241Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.874 6.015a1.286 1.286 0 0 1-.122-.04c-.43-.164-.752-.553-.752-1.024 0-.556.45-1.013.997-.944a7.953 7.953 0 0 1 3.705 1.476 8.053 8.053 0 0 1 2.906 4.028 8.11 8.11 0 0 1 0 4.978 8.067 8.067 0 0 1-2.136 3.387c-.402.38-1.033.277-1.358-.173-.274-.381-.24-.887.011-1.274a1.309 1.309 0 0 1 .155-.195l.003-.003a6.05 6.05 0 0 0 1.423-2.364 6.082 6.082 0 0 0 0-3.734 6.04 6.04 0 0 0-2.18-3.021 5.978 5.978 0 0 0-2.53-1.07m-.003 0a1.28 1.28 0 0 1-.119-.027Z"
      fill="currentColor"
    />
    <path
      d="m7.908 7.293.015 1.54a.872.872 0 0 0 .857.863.824.824 0 0 0 .598-.243.838.838 0 0 0 .243-.602l-.045-4.48-4.449-.045a.83.83 0 0 0-.84.846.872.872 0 0 0 .857.863l1.573.016c-.038-.085 1.235 1.197 1.19 1.242Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.007 17.959c.04.006.08.015.119.026Zm.119.026c.041.011.082.024.122.04.43.164.752.553.752 1.024 0 .556-.45 1.013-.997.944a7.97 7.97 0 0 1-3.705-1.476 8.053 8.053 0 0 1-2.906-4.028 8.11 8.11 0 0 1 0-4.978 8.066 8.066 0 0 1 2.135-3.387c.403-.38 1.034-.277 1.359.173.274.381.24.887-.011 1.274a1.293 1.293 0 0 1-.155.195l-.003.003a6.025 6.025 0 0 0-1.423 2.364 6.082 6.082 0 0 0 0 3.734 6.04 6.04 0 0 0 2.18 3.021 5.978 5.978 0 0 0 2.53 1.07"
      fill="currentColor"
    />
  </svg>
);

export default SvgReloadDoneOutlined;
